exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.padding-L[data-v-56212078] {\n  padding-left: 7px;\n}\n.padding-R[data-v-56212078] {\n  padding-right: 7px;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-56212078] {\n    padding-right: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/PackagesControl.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;AACA;IACI,iBAAiB;CACpB;CACA","file":"PackagesControl.vue","sourcesContent":["\n.padding-L[data-v-56212078] {\n  padding-left: 7px;\n}\n.padding-R[data-v-56212078] {\n  padding-right: 7px;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-56212078] {\n    padding-right: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56212078","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Routing/PackagesControl.vue
// module id = 1316
// module chunks = 0